import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import sha256 from 'crypto-js/sha256';
import { Subscription } from 'rxjs';
import { ImageCropperDialogComponent } from 'src/app/components/shared-components/image-cropper-dialog/image-cropper-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { RoutesHistoricService } from 'src/app/services/routes-services/routes-historic-service/routes-historic.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';

@Component({
  selector: 'app-users-new-user-creation-card',
  templateUrl: './users-new-user-creation-card.component.html',
  styleUrls: ['./users-new-user-creation-card.component.scss']
})
export class UsersNewUserCreationCardComponent implements OnInit, OnDestroy {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  base64;
  width: number;
  height: number;
  showSpinner: boolean;
  showButton: boolean;
  rememberedPermissions;
  addNewUserSubscription: Subscription;
  basicDataForm = new FormGroup({
    firstname: new FormControl(null, Validators.required),
    lastname: new FormControl(null, Validators.required),
    username: new FormControl(null, Validators.required),
    password: new FormControl(null, Validators.required),
    email: new FormControl(null, Validators.email),
    active: new FormControl(null, Validators.required)
  });

  constructor(private validationImageService: ValidationImageService,
              private userStorageService: UserStorageService,
              private userService: UserService,
              private snackbarService: SnackBarService,
              private spinnerService: SpinnerService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private routesHistoricService: RoutesHistoricService,
              public dialog: MatDialog) {
                this.showButton = true;
                this.width = 200;
                this.height = 200;
  }

  ngOnInit() {
    if (this.routesHistoricService.getPreviousUrl() !== '/account/user/role') {
      this.userService.deleteAllRememberedPermissions();
    } else {
      this.rememberedPermissions = this.userService.getRememberedPermissions();
      this.base64 = this.userService.getRememberedUserImage();
      this.basicDataForm = this.userService.getRememberedUserForm();
    }
  }

  public addNewUser() {
    const validation = this.validateForm();
    if (validation === true) {
      this.showButton = false;
      this.spinnerService.show('user-new-spinner');
      const hashedPassword = sha256(this.basicDataForm.get('password').value).toString().toUpperCase();
      this.addNewUserSubscription = this.userService.addNewUser(this.userStorageService.getCompanyData().CompanyCode, this.basicDataForm.get('firstname').value, this.basicDataForm.get('lastname').value, this.basicDataForm.get('username').value, hashedPassword, this.basicDataForm.get('email').value, this.base64, this.rememberedPermissions).subscribe(
        (res) => {
          this.spinnerService.hide('user-new-spinner');
          this.snackbarService.open('users-page.snackbar messages.add user success', 'success');
          this.router.navigate(['../../users'], {relativeTo: this.activatedRoute});
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
          this.spinnerService.hide('user-new-spinner');
          this.showButton = true;
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('user-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public addPermission() {
    this.userService.rememberUserInfo(this.base64, this.basicDataForm);
    this.router.navigate(['role'], { relativeTo: this.activatedRoute });
  }

  public deletePermission(permission) {
    this.userService.deleteRememberedPermission(permission);
  }

  public validateForm() {
    if (!this.basicDataForm.get('username').valid) {
      return 'users-page.snackbar messages.username required error';
    } else if (!this.basicDataForm.get('password').valid) {
      return 'users-page.snackbar messages.password required error';
    } else if (!this.basicDataForm.get('firstname').valid) {
      return 'users-page.snackbar messages.firstname required error';
    } else if (!this.basicDataForm.get('lastname').valid) {
      return 'users-page.snackbar messages.lastname required error';
    } else if (!this.basicDataForm.get('email').valid) {
      return 'users-page.snackbar messages.email format error';
    } else {
      return true;
    }
  }

  public cancelUser() {
    this.router.navigate(['../../users'], {relativeTo: this.activatedRoute});
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          data: { image: base64, width: this.width, height: this.height }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.base64 = result;
          }
        });
      },
      (error) => {
        this.snackbarService.open(error, 'error');
      }
    );
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  ngOnDestroy() {
    if (this.addNewUserSubscription) { this.addNewUserSubscription.unsubscribe(); }
  }
}
